window.authenticityToken = document.querySelector("[name='csrf-token']").content;

let icon1 = document.getElementById("icon1");
let menu1 = document.getElementById("menu1");
const showMenu1 = (flag) => {
  if (flag) {
    icon1.classList.toggle("rotate-180");
    menu1.classList.toggle("hidden")
  }
}
let icon2 = document.getElementById("icon2");

const showMenu2 = (flag) => {
  if (flag) {
    icon2.classList.toggle("rotate-180");
  }
}
let icon3 = document.getElementById("icon3");

const showMenu3 = (flag) => {
  if (flag) {
    icon3.classList.toggle("rotate-180");
  }
};

let Main = document.getElementById("Main");
let open = document.getElementById("open");
let close = document.getElementById("close")

const showNav = (flag) => {
  if (flag) {
    Main.classList.toggle("-translate-x-full")
    Main.classList.toggle("translate-x-0")
    open.classList.toggle("hidden");
    close.classList.toggle("hidden")
  }
};

window.serializeForm = (data) => {
  let obj = {};
  for (let [key, value] of data) {
    if (obj[key] !== undefined) {
      if (!Array.isArray(obj[key])) {
        obj[key] = [obj[key]];
      }
      obj[key].push(value);
    } else {
      obj[key] = value;
    }
  }
  return obj;
}

window.notify = (icon, title, position = 'top-end') => {
  swal.fire({position, icon, title, showConfirmButton: false, timer: 2500})
}

window.openSwappaSaleImportModal = async function openSwappaSaleImportModal() {
  const results = await Swal.fire({
    title: 'Import Swappa Sales',
    input: 'file',
    text: 'Importing sales will overwrite existing sale data',
    showCancelButton: true,
    confirmButtonText: 'Start Import',
    showLoaderOnConfirm: true,
    inputAttributes: {
      'accept': 'text/csv',
      'aria-label': 'import_swappa_sales'
    },
    allowOutsideClick: () => !Swal.isLoading(),
    preConfirm: async (file) => {
      try {
        const rawResponse = await fetch('<%= import_swappa_sales_path %>', {
          method: 'post',
          headers: {
            'accept': 'application/json',
            'content-type': 'text/plain',
            "x-csrf-token": document.querySelector("[name='csrf-token']").content,
          },
          body: file
        });
        if (!rawResponse.ok) {
          Swal.showValidationMessage(
            `Request failed: ${rawResponse.statusText}`
          )
        }
        const data = await rawResponse.json();
        console.log({data})
        return data
      } catch (error) {
        Swal.showValidationMessage(
          `Request failed: ${error}`
        )
      }
    }
  })
}

window.importSickwHistory = async function fileUploadEvent(event, options = {}) {
  const file = event.target.files[0];
  const formData = new FormData();
  formData.append('file', file);
  if (options.purchaseOrderId) {
    formData.append('purchase_order_id', options.purchaseOrderId)
  }

  await axios.post('/searches/import_sickw_history', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

window.fetcher = async (url, params = {}) => {
  let response;
  if (params.method.toLowerCase() === 'get' || !params.method) {
    response = await fetch(url + new URLSearchParams({
      ...params,
      authenticity_token: authenticityToken
    }))
    return await response.json()
  } else {
    console.log({params})
    console.log({url})
    let requestParams = {
      method: params.method,
      body: JSON.stringify(params),
      headers: {authenticity_token: authenticityToken}
    }
    console.log({requestParams})
    return fetch(url, requestParams)
      .then(response => response.json())
  }
}

